import React from "react";
import "./Contact.css";

function ContactPage() {
  return (
    <section className="contact-page" id="contact">

      {/* BACKGROUND */}
      <div className="contact-noise"></div>

      <div className="contact-glow contact-glow-one"></div>
      <div className="contact-glow contact-glow-two"></div>

      <div className="contact-wrapper">

        {/* ================= LEFT ================= */}

        <div className="contact-left">

          <div className="contact-tag">
            <span></span>
            CONNECT WITH CULTURE
            <span></span>
          </div>

          <h1>
            Let’s build something
            <br />
            <em>meaningful together.</em>
          </h1>

          <p className="contact-description">
            Whether you’re shaping a brand, launching a product,
            or telling a story — The Culture Capsule is here
            to bring clarity, creativity, and impact.
          </p>

          <div className="contact-info">

            <a href="mailto:siddharth@theculturecapsule.in">
              <span>EMAIL</span>
              siddharth@theculturecapsule.in
            </a>

            <a href="mailto:malika@theculturecapsule.in">
              <span>EMAIL</span>
              malika@theculturecapsule.in
            </a>

            <div>
              <span>LOCATION</span>
              Mumbai, India
            </div>

          </div>

        </div>


        {/* ================= RIGHT ================= */}

        <div className="contact-right">

          <div className="form-heading">

            <span>START A CONVERSATION</span>

            <div></div>

          </div>

          <form className="contact-form">

            {/* NAME */}
            <div className="input-group">

              <input
                type="text"
                id="contact-name"
                name="name"
                placeholder=" "
                required
              />

              <label htmlFor="contact-name">
                Your Name
              </label>

            </div>


            {/* EMAIL */}
            <div className="input-group">

              <input
                type="email"
                id="contact-email"
                name="email"
                placeholder=" "
                required
              />

              <label htmlFor="contact-email">
                Email Address
              </label>

            </div>


            {/* COMPANY */}
            <div className="input-group">

              <input
                type="text"
                id="contact-company"
                name="company"
                placeholder=" "
                required
              />

              <label htmlFor="contact-company">
                Company
              </label>

            </div>


            {/* MESSAGE */}
            <div className="input-group textarea-group">

              <textarea
                id="contact-message"
                name="message"
                rows="5"
                placeholder=" "
                required
              ></textarea>

              <label htmlFor="contact-message">
                Tell us about your idea
              </label>

            </div>


            {/* BUTTON */}
            <button
              type="submit"
              className="send-btn"
            >
              <span>Send Message</span>
              <span className="send-arrow">↗</span>
            </button>

          </form>

        </div>

      </div>


      {/* ================= BOTTOM ================= */}

      <div className="contact-bottom">

        <div></div>

        <p>
          THINK.
          <span> CREATE.</span>
          <span> CONNECT.</span>
        </p>

        <div></div>

      </div>

    </section>
  );
}

export default ContactPage;